/**
 * ProgressEvent — renderiza tipo 'progress'
 * payload: { paso, label, pct? }
 * R-PT-07: estado de avance visible para operaciones largas.
 */

import { Loader } from 'lucide-react'

export default function ProgressEvent({ payload }) {
  const { label, pct } = payload

  return (
    <div className="event-progress">
      <span className="event-progress__spinner" aria-hidden="true"><Loader className="icon-spin" size={14} strokeWidth={1.8} /></span>
      <span className="event-progress__label">{label}</span>
      {pct !== undefined && (
        <div className="event-progress__bar-wrap" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}>
          <div className="event-progress__bar" style={{ width: `${pct}%` }} />
        </div>
      )}
    </div>
  )
}
